var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","value":true,"icon":"new_releases"},on:{"input":_vm.onClose}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.link && _vm.link_text)?_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.link_text))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055f3de1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Alert.vue
// module id = null
// module chunks = 